import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import IconButton from '@mui/material/IconButton';
import { useCallback } from 'react';
import { VolumeHighIcon } from '../../icons/volumeHighIcon';
import { VolumeMuteIcon } from '../../icons/volumeMuteIcon';
import { thunkSetSoundVolume } from '../../redux/actions/selfDataActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { LIGHT_RED_COLOR } from '../../styles/colors';
const SOUND_OFF_CSS = css `
  color: ${LIGHT_RED_COLOR};
`;
/**
 * Sound volumes are saved as negative numbers when muted to preserve what volume level was set at the time of muting.
 */
export const SoundToggleButton = () => {
    const dispatch = useAppDispatch();
    const soundVolumePercent = useAppSelector((state) => state.selfData.userClientSettings.SOUND_VOLUME.percent);
    const isSoundOn = soundVolumePercent > 0;
    const onClick = useCallback(() => {
        const absoluteSoundVolumePercent = Math.abs(soundVolumePercent);
        // avoid negative zero (because that's weird):
        const newSoundVolumePercent = absoluteSoundVolumePercent === 0 ? 0 : (isSoundOn ? -1 : 1) * absoluteSoundVolumePercent;
        dispatch(thunkSetSoundVolume(newSoundVolumePercent));
    }, [dispatch, isSoundOn, soundVolumePercent]);
    return (_jsx(IconButton, { css: !isSoundOn && SOUND_OFF_CSS, onClick: onClick, size: 'medium', title: isSoundOn ? 'Mute' : 'Unmute', children: isSoundOn ? _jsx(VolumeHighIcon, {}) : _jsx(VolumeMuteIcon, {}) }));
};
